"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TXIDVersion = void 0;
// Must match TXIDVersion in Engine.
var TXIDVersion;
(function (TXIDVersion) {
    TXIDVersion["V2_PoseidonMerkle"] = "V2_PoseidonMerkle";
})(TXIDVersion || (exports.TXIDVersion = TXIDVersion = {}));
